import React from 'react';
import SIcon from './SIcon';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faPlusCircle} fa />;

export default Icon;
